import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import actions from './actions'
import mutations from './mutations'
import menuItems from './menu-items'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  mutations,

  state: {
    // app
    appDrawer: null,
    stateless: false,
    menu: menuItems,
    loginDialog: false,
    filtersSidebar: false,
    group_required: false,
    selectedGroup: { 'id': null, 'description': 'New Group', 'visibility_type_id': 0, 'filers': [] },
    excludedGroup: { 'id': null, 'description': 'New Group', 'visibility_type_id': 0, 'filers': [] },
    selectedStockGroup: { 'id': null, 'description': 'New Group', 'visibility_type_id': 0, 'stocks': [] },
    excludedStockGroup: { 'id': null, 'description': 'New Group', 'visibility_type_id': 0, 'stocks': [] },
    show_whalescore_filers: false,
    show_funds_by_performance: false,
    show_heat_map_option: false,

    quarters: [],
    backtests: [],
    sectors: [],
    email_alerts: [],
    classifications: [],
    countries: [],
    sec_code_states: [],
    news: [],
    states: [],
    ww_groups: [],
    insider_alerts: [],
    insider_alerts_promise: null,
    ownershiptcodes: [],
    groups_promise: null,
    quarters_promise: null,
    backtests_promise: null,
    sectors_promise: null,
    email_alerts_promise: null,
    classifications_promise: null,
    countries_promise: null,
    sec_code_states_promise: null,
    states_promise: null,
    ww_groups_promise: null,
    ownershiptcodes_promise: null,

    // user specific
    limit: 5,
    is_team_member: false,
    is_subscriber: false,
    is_pro_subscriber: false,
    is_enterprise_subscriber: false
  },

})
